export const faqItems = [
  {
    question: '抗衰老应该从多少岁开始？',
    answer: '抗衰老不是老年人的专属话题。科学研究表明，25岁之后皮肤中的胶原蛋白开始以每年约1%的速度流失。建议25岁开始进行基础抗衰防护（防晒+抗氧化），30岁加强修护和营养补充，35岁后根据个人情况考虑更系统的抗衰方案。越早开始，效果越好。',
  },
  {
    question: '防晒真的那么重要吗？',
    answer: '是的，防晒是抗衰老中性价比最高的手段。紫外线（尤其是UVA）能穿透真皮层，破坏胶原蛋白和弹性纤维，导致光老化。研究表明，每天使用防晒的人皮肤老化速度比不使用者慢24%。即使在室内和阴天，也建议使用SPF30+的防晒产品。',
  },
  {
    question: '胶原蛋白补充剂真的有效吗？',
    answer: '水解胶原蛋白肽的临床研究结果总体是积极的。每天服用2.5-10g水解胶原蛋白肽并持续8周以上，能显著改善皮肤弹性和水合度，减少皱纹深度。建议选择I型和III型胶原的组合产品，并与维生素C同服以提高吸收效率。',
  },
  {
    question: '运动和抗衰老有什么关系？',
    answer: '运动是最天然的抗衰老方式之一。规律的有氧运动能促进血液循环、提升细胞氧合水平；力量训练维持肌肉量和骨密度；柔韧性训练保持身体灵活性。综合来看，每周150分钟中等强度运动加上2次力量训练，能有效延缓生物年龄。',
  },
  {
    question: '护肤品越贵抗衰效果越好吗？',
    answer: '不一定。护肤效果取决于活性成分的浓度和配方技术，而非价格。关键看成分表：维生素C、视黄醇、烟酰胺、透明质酸、神经酰胺等都是经过验证的有效抗衰成分。正确的使用顺序和坚持使用比品牌和价格更重要。',
  },
  {
    question: '睡眠不足真的会让人变老吗？',
    answer: '会的。睡眠是身体修复的黄金时间，深度睡眠期间生长激素分泌达到高峰，促进细胞修复和胶原蛋白合成。长期睡眠不足会导致皮质醇升高、炎症水平增加、皮肤屏障功能下降。研究表明，睡眠质量差的人皮肤老化迹象比同龄人明显更多。',
  },
  {
    question: '抗衰老饮食最重要的是什么？',
    answer: '核心原则是"抗氧化+抗炎+营养均衡"。多吃富含抗氧化物的深色蔬果（蓝莓、西兰花、番茄等），摄入优质蛋白和Omega-3脂肪酸（鱼类、坚果），减少精制糖和加工食品。糖分会与胶原蛋白发生糖化反应，是皮肤老化的加速器。',
  },
];